import { SxProps } from "@mui/material";
import colors from "../../theme/Colours";

export const mainContainer: SxProps = {
  display: "flex",
  backgroundColor: { xs: "none", sm: colors.background2 },
  gap: { xs: "20px", md: "38px" },
  paddingY: { xs: "10px", sm: "15px" },
  paddingRight: "44px",
};

export const titleStyle: SxProps = {
  fontFamily: "Poppins",
  fontSize: { xs: "12px", sm: "18px" },
  fontWeight: 500,
  color: colors.buttonBGColor,
};

export const orderStyles: SxProps = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: { sm: "space-between" },
  gap: { xs: "26px", sm: "0" },
  flexGrow: 1,
};

export const textStyle: SxProps = {
  fontFamily: "Poppins",
  fontSize: { xs: "8px", sm: "16px" },
  fontWeight: 400,
  color: colors.buttonBGColor,
};

export const spaceBetween: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: { xs: "6px", sm: "12px" },
};

export const calculationBox: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontFamily: "Poppins",
  fontSize: { xs: "10px", sm: "15px" },
  fontWeight: 600,
  color: colors.buttonBGColor,
  borderWidth: "1px",
  borderRadius: "8px",
  borderColor: colors.black,
  padding: { xs: "2px 6px", sm: "0px 11px" },
  width: { xs: "123px", sm: "160px" },
  height: { xs: "20px", sm: "36px" },
};

export const inheritFont: SxProps = {
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
};

export const titleWithEditContainer: SxProps = {
  display: "flex",
  gap: 1,
  flexDirection: "row",
  minHeight: "40px",
  alignItems: "center",
};

export const deleteIconStyle = {
  width: 16,
  height: 18,
};
